<template>
  <div class="RwvContentHtmlEdit">
      <b-form-group
        :id="'input-group-content-html-' + index"
        :label-for="'input-content-html-' + index"
        valid-feedback>

        <b-form-textarea
          :id="'input-content-html' + index"
          v-model="html"
          required
          placeholder="HTML hier..."
          v-b-tooltip.hover
          title="HTML">
          </b-form-textarea>
      </b-form-group>
  </div>
</template>

<script>
export default {
  name: "RwvContentHtmlEdit",
  props: {
    html: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  watch: {
    html(html) {
      this.$emit("changed", html)
    }
  }
};
</script>
